export default __webpack_public_path__ + "static/media/psi.457bea4f.png";